<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">
    
    <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">{{ (isNew ? 'tag.edit.titleAdd' : 'tag.edit.titleEdit') | translate }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup" class="w-100 col-lg-8">
        <div class="row">
          <div class="col-12 mb-3">
            <label class="form-label">{{ 'tag.edit.keywordsLabel' | translate }}</label>
            <mat-chip-grid #chipGrid>
              <input 
                type="text"
                class="form-control"
                [placeholder]="'tag.edit.keywordPlaceholder' | translate"
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="add($event)" />
                @for (item of keywords; track item) {
                <mat-chip-row (removed)="remove(item)" [editable]="false">
                  {{item}}
                  <button matChipRemove [attr.aria-label]="('tag.edit.removeKeywordAria' | translate) + ' ' + item">
                    <i class="mdi mdi-close"></i>
                  </button>
                </mat-chip-row>
                }
            </mat-chip-grid>
          </div>

          <div class="col-12 mb-3">
            <label class="form-label">{{ 'tag.edit.titleLabel' | translate }}</label>
            <input
              formControlName="title"
              class="form-control"
              [placeholder]="'tag.edit.titlePlaceholder' | translate"
              maxlength="100" />
            <field-error-component [field]="'title'" [label]="('tag.edit.titleFieldLabel' | translate)" [formGroup]="formGroup" />
          </div>

          <div class="col-12 mb-3">
            <div class="row">
              <div class="col-md-6">
                <label class="form-label">{{ 'tag.edit.bgColorLabel' | translate }}</label>
                <div class="d-flex align-items-center gap-2">
                  <input 
                    formControlName="bgColor" 
                    class="form-control"
                    placeholder="#A5A6F6"
                  />
                  <div 
                    class="border rounded d-flex align-items-center justify-content-center custom-box" 
                    style="width: 50px; height: 40px; cursor: pointer;"
                    [(colorPicker)]="colorBg"
                    [style.background]="colorBg"
                    (colorPickerSelect)="selectColor()">
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{ 'tag.edit.fontColorLabel' | translate }}</label>
                <div class="d-flex align-items-center gap-2">
                  <input 
                    formControlName="fontColor" 
                    class="form-control"
                    placeholder="#000"
                  />
                  <div 
                    class="border rounded d-flex align-items-center justify-content-center" 
                    style="width: 50px; height: 40px; background-color: #000000; cursor: pointer;"
                    [(colorPicker)]="colorFont"
                    [style.background]="colorFont"
                    (colorPickerSelect)="selectColorFont()">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mb-4">
            <label class="form-label">{{ 'tag.edit.previewLabel' | translate }}</label>
            <div>
              <span class="badge font-14 text-capitalize"
                [ngStyle]="{
                  'background-color': formGroup.get('bgColor')?.value || '#6c757d',
                  'color': ((formGroup.get('bgColor')?.value || '#6c757d') | readableText: (formGroup.get('fontColor')?.value || '#ffffff'))
                }">
                {{ formGroup.get('title')?.value || ('tag.edit.previewPlaceholder' | translate) }}
              </span>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'tag.edit.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid"
        (click)="save()"
      >
        {{ (isNew ? 'tag.edit.save' : 'tag.edit.update') | translate }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>

  </div>
</div>